import { render, staticRenderFns } from "./LawCollectionEntity.vue?vue&type=template&id=15036219&scoped=true"
import script from "./LawCollectionEntity.vue?vue&type=script&lang=js"
export * from "./LawCollectionEntity.vue?vue&type=script&lang=js"
import style0 from "./LawCollectionEntity.vue?vue&type=style&index=0&id=15036219&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15036219",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15036219')) {
      api.createRecord('15036219', component.options)
    } else {
      api.reload('15036219', component.options)
    }
    module.hot.accept("./LawCollectionEntity.vue?vue&type=template&id=15036219&scoped=true", function () {
      api.rerender('15036219', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LawCollectionEntity.vue"
export default component.exports